import { requestPhoenix } from '../network';
import { KalturaCategoryTree } from '../objects';

export type FetchCategoryTreeByIdArgs = {
  categoryItemId: number;
  filter?: boolean;
};

export type FetchCategoryTreeByVersionArgs = {
  deviceFamilyId?: number;
  versionId?: number;
};

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/categoryTree/action/get
 */
export function fetchCategoryTreeById({ categoryItemId, filter }: FetchCategoryTreeByIdArgs) {
  return requestPhoenix<KalturaCategoryTree>({
    path: '/categorytree/action/get',
    body: { categoryItemId, filter },
  });
}

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/categoryTree/action/getByVersion
 */
export function fetchCategoryTreeByVersion({ deviceFamilyId, versionId }: FetchCategoryTreeByVersionArgs) {
  return requestPhoenix<KalturaCategoryTree>({
    path: '/categorytree/action/getByVersion',
    body: { deviceFamilyId, versionId },
  });
}
